import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { inject, observer } from "mobx-react/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatNullableValue } from '../../../utils/formatar';
import { IconeSetaDireita, IconeSetaDescer } from '../../comum/components/Icones'
import PopupOpenIcone from '../../comum/components/PopupOpenIcone'
import { Row, Col } from "reactstrap";

@inject("store")
@observer
export default class CardDetalhe extends Component {
    constructor(props) {
        super(props);
        this.dimensaoColuna = this.props.titulo2 ? 6 : 12;
    }

    renderColuna = (titulo, descricao, formatacao) => {
        return (
            <Col xl={this.dimensaoColuna} lg={this.dimensaoColuna} md={this.dimensaoColuna}>
                {this.props.hasPopUp && <PopupOpenIcone className="card-detalhe--pop-icon" /> /*hasPopUp recebe um bool que identifica se este card tem um popup ou não */}
                {titulo && <h5>{titulo}</h5>}
                {descricao && (
                    (titulo == "Containers")
                        ? <Link to={{
                            pathname: `/containers-detalhes/${descricao}`,
                            state: {
                                codigoContainer: descricao,
                                operacaoBooking: this.props.operacaoBooking,
                                codigoBooking: this.props.booking,
                                entradaCntr: this.props.entradaCntr
                            }
                        }}>{descricao}</Link>
                        : descricao &&
                        <div className="desc2">
                            {formatacao ?
                                formatNullableValue(formatacao(descricao))
                                :
                                (descricao == 2 ?
                                    <div>
                                        {descricao[0]}
                                        <span className="de-para">  </span>
                                        {descricao[1]}
                                    </div>
                                    :
                                    typeof descricao === "string" || React.isValidElement(descricao)
                                        ? descricao
                                        : formatNullableValue(Array.isArray(descricao) ? descricao.join('') : descricao || '')
                                )
                            }
                        </div>
                )}
            </Col>);
    }

    render() {
        return (
            <div>
                <div className={`card-detalhe ${this.props.onClick ? "card-detalhe--clickable" : ""} ${this.props.pt ? this.props.pt : ""} ${this.props.pb ? this.props.pb : ""}`} onClick={this.props.onClick}>
                    {this.props.icone && <span className="icone">{this.props.icone}</span>}
                    <div className="card-detalhe--conteudo">
                        <Row>
                            {this.renderColuna(this.props.titulo, this.props.desc, this.props.formatacao)}
                            {this.props.titulo2 && this.renderColuna(this.props.titulo2, this.props.desc2, this.props.formatacao2)}
                        </Row>
                    </div>
                    {this.props.label && <div className="label">{this.props.label}</div>}
                </div>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/CardDetalhe.js